/**
 * The WagePro app icon, as shown on the phone home screen and in Google Play:
 * the shared Jumpstone mark in white on a rounded `--wagepro-brand` tile.
 *
 * The Android launcher icon (`apps/wagepro-mobile/android/.../ic_launcher*`)
 * is that white mark on the launcher background, which matches
 * `--wagepro-brand`, so the web top bars render this instead of the bare black
 * mark, keeping the brand identical across web and mobile. The mark itself is still the shared
 * `/brand/logo-mark-dark.svg` (CLAUDE.md § Branding: one mark across every
 * product); only the tile colour is WagePro's.
 *
 * One component owns this so the employer and employee bars cannot drift.
 * Size lives in CSS (`.wp-app-icon`, 28px), not a prop, so context rules such
 * as the phone employee header's 32px `.wp-topbar-mark` can still override it.
 */
export function WageProAppIcon({
  alt,
  className,
}: {
  /** Accessible name; pass `''` where an adjacent wordmark already names it. */
  alt: string;
  className?: string;
}): React.JSX.Element {
  return (
    <span
      className={className ? `wp-app-icon ${className}` : 'wp-app-icon'}
      data-testid="wagepro-app-icon"
    >
      <img
        src="/brand/logo-mark-dark.svg"
        alt={alt}
        className="wp-app-icon-mark"
      />
    </span>
  );
}
